import { gis2QueryUrl } from '../../../utils/urls.js'

export default {
  layer: {
    id: "loac",
    "source-layer": "loac_2021",
    type: "fill",
    paint: {
      "fill-color": "lightgrey",
      "fill-opacity": 0.7,
      "fill-outline-color": 'black',
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "loac",
    'type': 'vector',
    'tiles': ["https://d1lfm2zniswzpu.cloudfront.net/loac-2021/{z}/{x}/{y}.mvt"],
    'minzoom': 6,
    'maxzoom': 14
  },
  labels: {
    parent: "Census Demographic Classification (LOAC)",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: false,
  category: "hsds",
  noColourPicker: true,
  toggleColor: "lightgrey",
  popupType: "loac-group",
  info: {
    shortDescription:
      "London Output Area Classification (LOAC) from the 2021 Census.",
    longDescriptionTitle: "London Output Area Classification (LOAC)",
    longDescription: [
      (<><b>Description by the Consumer Data Research Centre (CDRC):</b></>),
      (<>The London Output Area Classification (LOAC) is a geodemographic that summarises the built and population characteristics of all 2021 Output Areas within Greater London. The region is organised into a hierarchical typology composed of 7 Supergroups and 16 Groups. The classification was created from the 2021 Census data and was a partnership between the Consumer Data Research Centre, University College London and the University of Liverpool.</>),        
      "CDRC LOAC by the ESRC Consumer Data Research Centre; Contains National Statistics data Crown copyright and database right 2023; Contains Ordnance Survey data Crown copyright and database right 2023.",
      (<>Full dataset and methodology are available here: <a href="https://data.cdrc.ac.uk/dataset/london-oac" target="_blank">London OAC (2021 Census Data)</a> under the <a href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/" target="_blank">UK Open Government Licence (OGL)</a></>)
    ]
  },
}